import { useQuery } from "@tanstack/react-query";
import { TResponse } from "./types";
import { GET } from "./client";

export const useGetTransferCounts = () => {
  return useQuery<TResponse<TransferStatusCounts>>({
    // 로그인 기능 완성 후 hosiptalCode 제거
    queryKey: [`/transfer/requests/status`],
    queryFn: () =>
      GET(`/transfer/requests/status`, { hospitalCode: "A1300002" }),
  });
};

export interface TransferStatusCounts {
  noResponse: number;
  accepted: number;
  rejected: number;
  canceled: number;
  transferring: number;
  completed: number;
}
